import { v5 } from 'uuid';

interface GenerateDmIdArgs {
  yourId: string;
  theirId: string;
  namespace: string;
}

export default function generateDmId({
  yourId,
  theirId,
  namespace,
}: GenerateDmIdArgs) {
  const id = [yourId, theirId].sort((a, b) => (a > b ? 1 : -1)).join('');
  if (namespace) return v5(id, namespace);
  return null;
}
